const mutation = {
    deleteCartItem: `
      mutation deleteCartItem($id: String!) {
            deleteCartItem (id: $id) {
                status,
                res,
                message
            }
        }
    `,
    saveCartList: `
      mutation saveCartList($data: JSONString!) {
            saveCartList (data: $data) {
                status,
                res,
                message
            }
        }
    `,
};

const query = {
    cartCount: `
        query ecommerceCartList($customerId: String!) {
            ecommerceCartList(customerId: $customerId) {
            id
            }
        }
    `,
    cartList: `
        query ecommerceCartList($customerId: String!, $dateNow: String!) {
            ecommerceCartList(customerId: $customerId) {
                id
                itemId
                name
                description
                price(dateNow: $dateNow)
                quantity
                stock
                total
                discount
                photoUrl
            }
        }
    `,
    cartInventoryItems: `
        query cartInventoryItems {
            cartInventoryItems {
                id
                featuredImagePath
                name
                description
                srp
                photoUrl
            }
        } 
    `,
    cartGroups: `
        query cartGroups($catId: String) {
            cartGroups(catId: $catId) {
                id
                title
                code
                categoryId
            }
        } 
    `
}

export { mutation, query };